





















































import { Component, Prop, Vue } from "vue-property-decorator";
import { Location } from "vue-router";
import { FriendRef } from "@dokogd/shared";
import cloneDeep from "lodash/cloneDeep";
import { WaitingPlayer } from "../../store/modules/desk/types";

@Component({})
export default class ItemRefList extends Vue {
  @Prop({
    type: Array,
    required: true,
  })
  ignore!: string[];

  @Prop({
    type: Array,
    required: true,
  })
  items!: (FriendRef | WaitingPlayer)[];

  @Prop({
    type: Number,
    default: 3,
  })
  visibleItems!: number;

  get freeItems() {
    console.log("freeItems", this.ignore, this.items);
    return this.items.filter((item) => !this.ignore.includes(item.id));
  }

  get style() {
    return {
      height: this.visibleItems * 48 + "px",
    };
  }

  selectionDone(idx: number) {
    const data = cloneDeep(this.freeItems[idx]);
    this.$emit("input", data);
  }
}
